import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7b982d6b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "login-account" }

import { reactive, ref } from 'vue'
import { ElForm } from 'element-plus'
import { useStore } from 'vuex'


export default /*#__PURE__*/_defineComponent({
  __name: 'login-account',
  setup(__props, { expose: __expose }) {

const store = useStore()

const rules = {
  empNo: { required: true, message: '员工编号是必传的', trigger: 'blur' },
  password: { required: true, message: '密码是必传的', trigger: 'blur' }
}

const formRef = ref<InstanceType<typeof ElForm>>()

const loginAction = () => {
  return new Promise<void>((resolve, reject) => {
    if (!formRef.value) {
      resolve()
      return
    }

    formRef.value.validate(async (isValid: boolean | undefined) => {
      if (!isValid) {
        resolve()
        return
      }

      try {
        await store.dispatch('login/accountLoginAction', { ...account })
        resolve()
      } catch (error) {
        reject(error)
      }
    })
  })
}

const account = reactive({
  empNo: '',
  password: ''
})
__expose({
  loginAction
})

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(ElForm), {
      rules: rules,
      model: account,
      ref_key: "formRef",
      ref: formRef
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form_item, {
          label: "账号",
          "label-width": "60px",
          prop: "empNo"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: account.empNo,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((account.empNo) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "密码",
          "label-width": "60px",
          prop: "password"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: account.password,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((account.password) = $event)),
              "show-password": ""
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["model"])
  ]))
}
}

})